import Player from "@/components/LottiePlayer";

export default function Features({ topTitle, title, featuredItems }) {
  return (
    <section className="relative w-screen max-w-screen overflow-hidden">
      <svg
        className=""
        width="2560"
        height="116"
        viewBox="0 0 2560 116"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2560 64.5909H1090.08C833.336 64.5909 580.229 0 360 0C139.771 0 0 64.5909 0 64.5909V116H2560V64.5909Z"
          fill="#F7F8F9"
        />
      </svg>
      <div className="bg-gradient-to-b from-[#f7f8f9] to-white -my-4 flex justify-center">
        <div className="container xl:max-w-5xl lg:max-w-4xl md:max-w-3xl px-4 pb-12 flex-col items-center">
          <div className="text-center text-maingray pt-20" tabindex={0}>
            <h3 className="text-center mx-auto mb-8 main-top-title">
              {topTitle}
            </h3>
            <p className="body-text mb-16 xl:mb-24 mx-auto">
              {title}
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 pb-10">
            {featuredItems.map(({ title, text, icon }) => (
              <div key={title} className="flex gap-4" tabindex={0}>
                <Player
                  autoplay
                  loop
                  src={icon}
                  style={{ height: "80px", width: "80px" }}
                />
                <div>
                  <h5 className="small-title">
                    {title}
                  </h5>
                  <p className="body-text">
                    {text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
